import React, { Component } from 'react'
import Consent from './Components/Consent'
import Payment from './Components/Payment';
import PageLoader from '../../Loader/loader';
import axios from 'axios';
import { getApiHeaderGuest } from '../../../utils/CommonFunctions';
import swal from 'sweetalert';
import Error from './Components/Error';
import { Display } from 'react-bootstrap-icons';


const SERVER_URL = process.env.REACT_APP_SERVER_URL;
class PostPaidTapResaleCommonModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: "",
      orderDetails: "",
      ParamsId: "",
      paramsValue: "",
      loading: false,
      paramName: "",
      paramValue: "",
      customer_details: "",
      payment_details: "",
      portin_details: "",
      errorMsg: "",
      common_data: "",
      plan_mapping:"",

    };
  }



  nextStep = (input) => {
    this.setState((prevState) => ({
      step: input,
    }));
  };


  prevStep = (input) => {
    this.setState((prevState) => ({
      step: input,
    }));
  };


  getOrderDetails = (input) => {
    this.setState(() => ({
      orderDetails: input
    }))
  }

  setLoading = (input) => {
    this.setState(() => ({
      loading: input
    }))
  }


  componentDidMount() {
    this.toggleChatVisibility()
    const searchParams = new URLSearchParams(window.location.search);
    const iterator = searchParams.entries().next();
    if (!iterator.done) {
      const [paramName, paramValue] = iterator.value;
      this.setState({
        paramName,
        paramValue
      });
      this.handleInitailFetch(paramName, paramValue)
    }

  }

  toggleChatVisibility() {
    const checkExist = setInterval(() => {
      const chat = document.getElementById("zsiq_float");
      if (chat) {
        chat.style.display = "none"; 
        clearInterval(checkExist); 
      }
    }, 100);
  }



  handleInitailFetch = async (paramName, paramValue) => {
    try {
      this.setLoading(true)
      const headers = await getApiHeaderGuest()
      const payload = {
        refIndex: paramName,
        refId: paramValue,
      }
      const response = await axios.post(`${SERVER_URL}postpaid/r-s-a-d`, payload, { headers })
      if (response.status === 200) {
        this.setLoading(false)
        const data = response.data.data
        this.nextStep(data?.next_page)
        this.setState(prevState => ({
          ...prevState,
          common_data: data.common_data,
          customer_details: data.customer_details,
          portin_details: data.portin_details,
          payment_details: {
            ...data.sim_details,
            ...data.plan_details,
            ...data.payment_details
          }
        }));

        const paymentData = {
          ...data.sim_details,
          ...data.plan_details,
          ...data.payment_details,
          ...data.customer_details,
          ...data.common_data,
        }
        this.getOrderDetails(paymentData)
      }
    } catch (error) {
       console.log("error======>",error)
      this.setLoading(false)
      if (!error.response?.data?.data?.next_page === "404") {
        swal({
          title: "Error",
          text: error.response?.data?.message,
          icon: "error",
        });
      } else {
        this.setState({ errorMsg: error?.response?.data?.message })
        this.nextStep(error.response?.data?.data?.next_page)
      }
    }
  }






  render() {

    return (
      <div>
        {(this.state.loading === true) ? <PageLoader /> : null}
        {this.state.step === "authorization" && (<Consent nextStep={this.nextStep} orderDetails={this.getOrderDetails} setLoading={this.setLoading} payment_details={this.state.payment_details} customer_details={this.state.customer_details} portinDetails={this.state.portin_details} common_data={this.state.common_data} planMapping={this.state.plan_mapping}  />)}
        {this.state.step === "payment" && (<Payment nextStep={this.nextStep} prevState={this.prevStep} step={this.state.step} orderDetails={this.state.orderDetails} setLoading={this.setLoading} paramName={this.state.paramName} paramValue={this.state.paramValue} portinDetails={this.state.portin_details} common_data={this.state.common_data} planMapping={this.state.plan_mapping}  />)}
        {this.state.step === "404" && (<Error nextStep={this.nextStep} prevState={this.prevStep} step={this.state.step} orderDetails={this.state.orderDetails} setLoading={this.setLoading} error={this.state.errorMsg} />)}
      </div>
    )
  }


}


export default PostPaidTapResaleCommonModule